<script setup lang="ts">
import { computed } from 'vue';

import { GrammarTertiaryButton } from '@nora-monorepo/grammar-ui';
import { DrawToolType } from '@nora-monorepo/nora-api-client';

import { getDrawToolNameByType, getIconByType } from '#nora-ui/map/drawtools/draw-tool-utils';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  drawToolType: DrawToolType;
  icon?: string; // If an icon is defined here we create a custom button to support the old icons too.
  mapId: string;
}

const props = defineProps<Props>();
const drawToolType = props.drawToolType;
const mapStore = useMapStore();
const map = mapStore.getMapByIdOrThrow(props.mapId);
const drawToolUI = map.drawToolUI;

const toolIcon = getIconByType(drawToolType);

const title = computed(() => {
  return getDrawToolNameByType(drawToolType);
});

function onToolSelected() {
  drawToolUI.closeToolList();

  switch (drawToolType) {
    case DrawToolType.symbol:
      // We also send the icon to the symbol tool so it can be drawn on the map
      return drawToolUI.setDrawToolByType(drawToolType, {
        fontIcon: props.icon,
      });
    default:
      return drawToolUI.setDrawToolByType(drawToolType);
  }
}
</script>

<template>
  <button
    v-if="props.icon"
    class="flex grammar-icon-button overflow-hidden items-center rounded-sm border justify-center text-center w-11 h-11"
    @click="onToolSelected"
  >
    <span class="grammar-icon">{{ props.icon }}</span>
  </button>
  <GrammarTertiaryButton
    v-else
    :icon-template="toolIcon"
    :title="title"
    @click="onToolSelected"
  />
</template>

<style scoped>
.grammar-icon-button {
  border: var(--borderWidthSm) solid var(--colorActionBorderDefault);
}

.grammar-icon-button:hover {
  border: var(--borderWidthSm) solid var(--colorActionBorderHighEmphasis);
}
</style>
